import React from 'react'

function IconBrush() {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 6.67676H1V1.67676C1 1.12447 1.44772 0.676758 2 0.676758H11V4.17676C11 4.4529 11.2239 4.67676 11.5 4.67676C11.7761 4.67676 12 4.4529 12 4.17676V0.676758H14C14.5523 0.676758 15 1.12447 15 1.67676V6.67676ZM1 7.67676H15V8.67676C15 9.78133 14.1046 10.6768 13 10.6768H10V15.0101C10 15.9306 9.10457 16.6768 8 16.6768C6.89543 16.6768 6 15.9306 6 15.0101V10.6768H3C1.89543 10.6768 1 9.78133 1 8.67676V7.67676Z'
        fill='#141414'
      />
    </svg>
  )
}

export default IconBrush
